export function loadScript(url: string, onLoadCallback?: Function, onErrorCallback?: Function) {
    // Adding the script tag to the head as suggested before
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    if (onLoadCallback) {
        (<any>script).onload = onLoadCallback;
    }

    if (onErrorCallback) {
        (<any>script).onerror = onErrorCallback;
    }

    // Fire the loading
    head.appendChild(script);
}
